/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RunsAttributesQueryDTO
 */
export interface RunsAttributesQueryDTO {
    /**
     * Filter attribute paths
     * @type {Array<string>}
     * @memberof RunsAttributesQueryDTO
     */
    attributePathsFilter: Array<string>;
    /**
     * List of experiment names
     * @type {Array<string>}
     * @memberof RunsAttributesQueryDTO
     */
    experimentNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RunsAttributesQueryDTO
     */
    projectIdentifier: string;
    /**
     * List of run identifiers. Supports UUID, qualified org/project/sysId, qualified CUSTOM/org/project/customId, and legacy bare sys/id scoped by projectIdentifier
     * @type {Array<string>}
     * @memberof RunsAttributesQueryDTO
     */
    runsIds?: Array<string>;
}

/**
 * Check if a given object implements the RunsAttributesQueryDTO interface.
 */
export function instanceOfRunsAttributesQueryDTO(value: object): value is RunsAttributesQueryDTO {
    if (!('attributePathsFilter' in value) || value['attributePathsFilter'] === undefined) return false;
    if (!('projectIdentifier' in value) || value['projectIdentifier'] === undefined) return false;
    return true;
}

export function RunsAttributesQueryDTOFromJSON(json: any): RunsAttributesQueryDTO {
    return RunsAttributesQueryDTOFromJSONTyped(json, false);
}

export function RunsAttributesQueryDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunsAttributesQueryDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'attributePathsFilter': json['attributePathsFilter'],
        'experimentNames': json['experimentNames'] == null ? undefined : json['experimentNames'],
        'projectIdentifier': json['projectIdentifier'],
        'runsIds': json['runsIds'] == null ? undefined : json['runsIds'],
    };
}

export function RunsAttributesQueryDTOToJSON(value?: RunsAttributesQueryDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attributePathsFilter': value['attributePathsFilter'],
        'experimentNames': value['experimentNames'],
        'projectIdentifier': value['projectIdentifier'],
        'runsIds': value['runsIds'],
    };
}

